// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__8Digu","title":"index_title__1I-ng"};